import { postDataApi } from '../utils/fech-api'; // Your Axios helper
import { getData, removeData, storeData } from '../utils/local-storage-helper';

const LOGIN_URL = '/auth';

export const loginUser = async (credentials) => {
    const response = await postDataApi(LOGIN_URL, credentials);

    // Store sensitive data in localStorage
    storeData(response.data, 'UBIZNEWS_AUTH_TOKEN');

    return response.data; // Return for further use if needed
};


export const logoutUser = () => {
    removeData('UBIZNEWS_AUTH_TOKEN')
    window.location.href = '/'
};

export const getAuthToken = () => {
    const authInfo = getData('UBIZNEWS_AUTH_TOKEN');
    return authInfo ? {token: authInfo?.token} : null
};

export const getAuthUser = () => {
    const user = localStorage.getItem('authUser');
    return user ? JSON.parse(user) : null;
};
